import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { FormsModule } from '@angular/forms';
import { HttpClientModule } from '@angular/common/http';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { AppConfigModule } from './config/app.config.module';
import { AppLayoutComponent } from './app.layout.component';
import { RouterModule } from '@angular/router';
import { AppBreadcrumbComponent } from './breadcrumbs/app.breadcrumb.component';
import { AppSidebarComponent } from './sidebar/app.sidebar.component';
import { AppTopbarComponent } from './topbar/app.topbar.component';
import { AppProfileSidebarComponent } from './profile-sidebar/app.profilesidebar.component';
import { AppMenuComponent } from './menu/app.menu.component';
import { AppMenuitemComponent } from './menu/app.menuitem.component';
import { NuriaChatComponent } from './nuria-chat/nuria-chat.component';

import { AnnouncementBannerComponent } from './announcement-banner/announcement-banner.component';
import { SharedModule } from '../shared/shared.module';
import { DividerModule } from 'primeng/divider';
import { LucideAngularModule } from 'lucide-angular';
import { LUCIDE_ICONS } from '../shared/lucide-icons';

@NgModule({
  declarations: [
    AppLayoutComponent,
    AppBreadcrumbComponent,
    AppSidebarComponent,
    AppTopbarComponent,
    AppProfileSidebarComponent,
    AppMenuComponent,
    AppMenuitemComponent,
    NuriaChatComponent,
    AnnouncementBannerComponent,
  ],
  imports: [
    BrowserModule,
    FormsModule,
    HttpClientModule,
    BrowserAnimationsModule,
    RouterModule,
    AppConfigModule,
    SharedModule,
    DividerModule,
    LucideAngularModule.pick(LUCIDE_ICONS),
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class AppLayoutModule {}
